import {Header} from "./Header";
import {Sidebar} from "./Sidebar";
import {Box, Typography} from "@mui/joy";
import {ReactElement, ReactNode} from "react";


export function PageStandard(props: {title: string, titleElement?: ReactElement, sidebarVisible: boolean, headerEnd?: ReactElement, children: ReactNode}) {

    const titleElement = props.titleElement || props.title

    return (
        <Box sx={{ display: 'flex', minHeight: '100dvh' }}>
            {
                props.sidebarVisible ?
                    <>
                        <Header />
                        <Sidebar />
                    </>
                    :
                    null
            }
            <Box
                component="main"
                className="MainContent"
                sx={{
                    px: { xs: 2, md: 6 },
                    pt: {
                        xs: 'calc(12px + var(--Header-height))',
                        sm: 'calc(12px + 4/3*var(--Header-height))',
                        md: 3,
                    },
                    paddingLeft: {
                        xs: 2,
                        md: 'calc(20vw + 3em)',
                        lg: 'calc(15vw + 3em)',
                    },
                    pb: { xs: 2, sm: 2, md: 5 },
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0,
                    height: '100dvh',
                    gap: 1,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        mb: {xs:0, md:1},
                        gap: 1,
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'start', sm: 'center' },
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography level="h2" component="h1">
                        {titleElement}
                    </Typography>
                    {
                        props.headerEnd ?
                            props.headerEnd
                            :
                            null
                    }
                </Box>
                {props.children}
            </Box>
        </Box>
    )
}